import { c as _c } from "react/compiler-runtime";
import { LoaderIcon } from "lucide-react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
const spinnerVariants = cva("animate-spin text-muted-foreground", {
  variants: {
    size: {
      xs: "size-3",
      // 12px - table rows, icon buttons
      sm: "size-4",
      // 16px - inline, small buttons
      md: "size-5",
      // 20px - default
      lg: "size-6",
      // 24px - section loading
      xl: "size-8",
      // 32px - card/modal center
      "2xl": "size-10" // 40px - full page
    }
  },
  defaultVariants: {
    size: "md"
  }
});
export interface SpinnerProps extends React.ComponentProps<"svg">, VariantProps<typeof spinnerVariants> {}
export function Spinner(t0) {
  const $ = _c(10);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      className,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== size) {
    t1 = cn(spinnerVariants({
      size
    }), className);
    $[4] = className;
    $[5] = size;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <LoaderIcon role="status" aria-label="Loading" className={t1} {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}